import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

type SelectOption = {
  id: string | number,
  description: string,
}

interface ISelect {
  value?: string | number | null;
  id: string;
  options: SelectOption[] | [];
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  onChange: (value: string | number) => void;
}

export default function SelectComponent({
  id,
  options,
  value = '',
  required = false,
  disabled = false,
  error = false,
  helperText,
  onChange,
}: ISelect) {
  return (
    <FormControl sx={{ width: '100%' }} error={error}>
        <Select
          id={id}
          value={value ?? ''}
          error={error}
          disabled={disabled}
          size="small"
          onChange={(event: SelectChangeEvent<string | number>) => onChange(event.target.value)}
        >
          {!required && (
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
          )}
          {options.map((item: SelectOption) => (
            <MenuItem key={item.id} value={item.id}>{item.description}</MenuItem>
          ))}
        </Select>
        {helperText && (
          <FormHelperText sx={{ marginLeft: 0, marginRight: 0 }}>{helperText}</FormHelperText>
        )}
    </FormControl>
  );
}
